import Riepilogo from 'components/riepilogo';
import Text from 'components/text';
import { dateFormat, onKeyPress } from 'helpers/utils';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { Alert, Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { addAnagraficaCedacri, getRicercaNdgCedacri, resetClienteRicercatoAction, resetClienteSelezionatoAction, resetErroreAddAnagraficaCedacriAction, resetNdg, setNdgAction } from './_redux/actions';
import { clienteRicercatoSelector, clienteSelezionatoSelector, erroreAddAnagraficaCedacri, ndgSelector } from './_redux/selectors';


const RicercaAnagrafe: React.FC = () => {

  const history = useHistory();
  const dispatch = useAppDispatch();
  const clienteSelezionato = useAppSelector(clienteSelezionatoSelector);
  const erroreAddAnagrafica = useAppSelector(erroreAddAnagraficaCedacri);
  const clienteRicercato = useAppSelector(clienteRicercatoSelector);
  const [modalAddContatto, setModalAddContatto] = useState(false)

  const ndg = useAppSelector(ndgSelector);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === 'Enter' && ndg) {
      ricerca();
    }
    onKeyPress(event);
  };

  const ricerca = () => {
    dispatch(getRicercaNdgCedacri())
  };

  const add = (forceInsert: boolean = false) => {
    forceInsert && removeErroreAddAnagraficaCedacri();
    dispatch(addAnagraficaCedacri(forceInsert));
    setModalAddContatto(false)

  };

  useEffect(() => {
    //console.log('useEffect su clienteSelezionato');
    if (clienteSelezionato) {
      history.push(`/admin/ricerca/${clienteSelezionato.ndg}`);
    }
  }, [history, clienteSelezionato]);

  useEffect(() => {
    if (history.action !== 'POP') {
      dispatch(resetClienteSelezionatoAction());
      dispatch(resetClienteRicercatoAction());
      dispatch(resetNdg());
    }
    return () => {
      dispatch(resetClienteSelezionatoAction());
    }
  }, [history.action, dispatch]);

  const removeErroreAddAnagraficaCedacri = () => {
    dispatch(resetErroreAddAnagraficaCedacriAction());
  };

  function onNdgChange(evt: any) {
    if (evt.target.value.length <= 12) {
      dispatch(setNdgAction(evt.target.value));
    }
  }

  return (
    <div>
      <div>
        <Row className="mb-3">
          <Col>
            <Text title="Ricerca cliente in anagrafe Cedacri" type='sottotitolo' />
          </Col>
        </Row>

        <Row className="mb-3">
          <Col md={9}>
            <Form.Control type="text" onKeyPress={(e: any) => handleKeyPress(e)} onChange={onNdgChange} value={ndg} placeholder="Cerca NDG" />
          </Col>
          <Col md={3}>
            <Button onClick={ricerca} className="button" disabled={!ndg}>Cerca</Button>
          </Col>
        </Row>

        {clienteRicercato && (
          <>
            <div className="mb-3">
              <Row>
                <Col md={12} className="mb-2">
                  <Alert key="info" variant="info">
                    <p>Il processo di certificazione contatti prevede la certificazione dell'<b>indirizzo email firma biometrica</b> e del <b>numero di cellulare</b> del cliente.</p>
                    <p>Al termine del processo di certificazione l'indirizzo <b>email di firma biometrica</b> andrà a sovrascrivere l'<b>indirizzo email anagrafe</b>.</p>
                  </Alert>
                </Col>
              </Row>
              <Row>
                <Col md={4} className="mb-2">
                  <Riepilogo chiave='Nome' valore={clienteRicercato.nome} />
                </Col>
                <Col md={8} className="mb-2">
                  <Riepilogo chiave='Cognome' valore={clienteRicercato.cognome} />
                </Col>
              </Row>
              <Row>
                <Col md={12} className="mb-2">
                  <Riepilogo chiave='Codice fiscale' valore={clienteRicercato.codiceFiscale} />
                </Col>
              </Row>
              <Row>
                <Col md={4} className="mb-2">
                  <Riepilogo chiave='Email anagrafe' valore={clienteRicercato.emailAnagrafe} />
                </Col>
                <Col md={8} className="mb-2">
                  <Riepilogo chiave='Email firma biometrica' valore={clienteRicercato.emailFirmaBiometrica} />
                </Col>
              </Row>
              <Row>
                <Col md={4} className="mb-2">
                  <Riepilogo chiave='Numero cellulare' valore={clienteRicercato.numeroCellulare} />
                </Col>
                <Col md={8} className="mb-2">
                  <Riepilogo chiave='Filiale prevalente' valore={clienteRicercato.filialeNdg} />
                </Col>
              </Row>
              <Row>
                <Col md={12} className="mb-2">
                  <Riepilogo chiave='Data ultima certificazione' valore={dateFormat(clienteRicercato?.dataUltimaCertificazione)} />
                </Col>
              </Row>
              <Row className="d-flex justify-content-center">
                <Col md={2} className="mb-2">
                  <Button className="button" onClick={() => setModalAddContatto(true)} disabled={!clienteRicercato}>Aggiungi</Button>
                </Col>
              </Row>
            </div>
          </>
        )}
      </div>

      <Modal
        show={modalAddContatto}
        onHide={() => setModalAddContatto(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Sei sicuro di voler procedere?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Sei sicuro di voler procedere con la certificazione dei dati dell' NDG selezionato?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModalAddContatto(false)}>
            Annulla
          </Button>
          <Button variant="primary" onClick={() => add()}>
            Prosegui
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={!!erroreAddAnagrafica}
        onHide={removeErroreAddAnagraficaCedacri}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Contatto già presente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {erroreAddAnagrafica?.message}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={removeErroreAddAnagraficaCedacri}>
            Annulla
          </Button>
          <Button variant="primary" onClick={() => add(true)}>
            Aggiungi
          </Button>
        </Modal.Footer>
      </Modal>

    </div>

  );
}

export default RicercaAnagrafe;
